import { comments } from '@/mocks/homepage';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            读者评论
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            来自真实读者的使用反馈，听听大家怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className={`bg-background-100 rounded-xl p-5 border border-background-200/70 ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              {/* Header */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <p className="text-[11px] text-foreground-400">{comment.source}</p>
                </div>
                <span className="ml-auto text-[11px] text-foreground-400 flex-shrink-0">{comment.date}</span>
              </div>

              {/* Text */}
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>

              {/* Rating */}
              <div className="mt-4 flex items-center gap-0.5 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}

          {/* Remaining in 2-col grid */}
          <div className="hidden lg:block"></div>
          <div className="hidden lg:block"></div>
        </div>
      </div>
    </section>
  );
}